module.exports = __webpack_public_path__ + "static/img/Jared-Waerea-Hargreaves.88a3d67.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jared-Waerea-Hargreaves.jpg
// module id = EfQD
// module chunks = 0